import { type ComponentProps, type PropsWithChildren } from 'react';
import { Platform, ScrollView, StyleSheet } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-controller';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderModalScrollView = (props: Props) => {
  const { children, keyboardAware = false, style, ...scrollViewProps } = props;

  // ─── Styles ──────────────────────────────────────────────────────────

  const scrollViewStyles = [styles.container, style];

  if (keyboardAware) {
    return (
      <KeyboardAwareScrollView style={scrollViewStyles} {...scrollViewProps}>
        {children}
      </KeyboardAwareScrollView>
    );
  }

  return (
    <ScrollView style={scrollViewStyles} {...scrollViewProps}>
      {children}
    </ScrollView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: Platform.select({ web: 1, default: undefined }),
    flexGrow: Platform.select({ web: undefined, default: 1 }),
    flexShrink: Platform.select({ web: undefined, default: 1 }),
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<
  ComponentProps<typeof KeyboardAwareScrollView> & {
    keyboardAware?: boolean;
  }
>;
